export const list = {
	listWrapper: { display: 'flex', flexDirection: 'column', gap: '2rem', paddingTop: '2rem' },
	item: {
		wrapper: { padding: 0, gap: '0.5rem', display: 'flex', alignItems: 'flex-start' },
		title: {
			marginTop: '0.3125rem',
			borderRadius: '3.125rem',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minWidth: '1.25rem',
			minHeight: '1.25rem',
			backgroundColor: 'secondary.main',
		},
		textWrapper: {
			display: 'flex',
			flexDirection: 'column',
			gap: '0.5rem',
		},
	},
};
